import * as FIELD_NAME from 'constant/form-item-names'
import * as FIELD_LABEL from 'constant/form-labels'
import * as RULES from 'constant/form-rules'
import * as NUMBER from 'constant/number'
import React from 'react'
import PropTypes from 'prop-types'
import { Form, Input } from 'antd'
import styles from '../styles.scss'

const SecondNameInput = ({ disabled = false }) => {
  return (
    <>
      <span>{FIELD_LABEL.LAST_NAME}</span>
      <Form.Item
        name={FIELD_NAME.LAST_NAME}
        rules={[RULES.REQUIRED, RULES.maxCharLength(NUMBER.ONE_HUNDRED)]}
      >
        <Input
          className={styles.form_input}
          disabled={disabled}
          placeholder={'Second Name'}
        />
      </Form.Item>
    </>
  )
}

SecondNameInput.propTypes = {
  disabled: PropTypes.bool
}
export default SecondNameInput
